import {mcatChatApi} from "./mcatChatApi";
import {
    MCatChatStartConversationRequest,
    MCatChatStartConversationResponse, MCatChatSubjectRequest,
    MCatChatSubjectResponse
} from "./types";

export const mcatChatConveration = mcatChatApi.injectEndpoints({
    endpoints: (builder) => ({
        getSubjects: builder.query<MCatChatSubjectResponse[], MCatChatSubjectRequest>({
            query: (params) => ({
                url: "/Api/AiEnrichment/GetSubjects",
                method: "GET",
                params
            }),
            providesTags: ["Subjects"]
        }),
        startConversation: builder.mutation<MCatChatStartConversationResponse, MCatChatStartConversationRequest>({
            query: (body) => ({
                url: "/Api/AiEnrichment/StartConversation",
                body: body,
                method: "POST",
            }),
        }),
    })
})

export const {
    useStartConversationMutation,
    useLazyGetSubjectsQuery,
} = mcatChatConveration;